const LogBookStyles = {
    root: {
        width: '100% !important',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'

    },

    itemContainer: {
        display: "flex",
        width: '90%',
        height: '70px',
        justifyContent: "center",
        alignItems: "center",
        margin: '9px 0 0 0',
        padding: '18px 6px',
        borderRadius: '16px',
        backgroundColor: '#F5F5F5',
        // boxShadow: '-8px -8px 25px 0 #FFFFFF',
    },
    prepost: {
        fontSize: '14px',
        color: '#707070',
        fontFamily: 'Kalameh',
        margin: 0
    },
    High: {
        border: 'solid 2px #feb140',
    },
    InRange: {
        border: 'solid 2px #3bba4c',
    },
    Low: {
        border: 'solid 2px #d81d5d',
    },
    timeIconBlue: {
        color: '#1fb9ee !important',
        fontSize: '15px'
    },
    timeIconPurple: {
        color: '#753cbe !important',
        fontSize: '15px'

    },
    sugar: {
        margin: 0,
        fontFamily: 'Kalameh',
        fontSize: '24px',
        fontWeight: 'bold'
    },
    sugarModal: {
        margin: 0,
        fontFamily: 'Kalameh',
        fontSize: '100px !important',
        fontWeight: 'bold'
    },
    sugarUnit: {
        margin: 0,
        fontFamily: 'Kalameh',
        fontSize: '13px',
        fontWeight: 'bold'
    },
    HighColor: {
        color: '#feb140',
    },
    InRangeColor: {
        color: '#3bba4c',
    },
    LowColor: {
        color: '#d81d5d',
    },
    HypoRate: {
        display: 'flex',
        justifyContent: "center",
        alignItems: 'center',
        fontFamily: 'Kalameh',
        fontSize: '16px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        textAlign: 'center',
        color: '#d81d5d',
    },
    HypoDate: {
        display: 'flex',
        justifyContent: "center",
        alignItems: 'center',
        fontFamily: 'Kalameh',
        fontSize: '16px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        textAlign: 'left',
        color: '#707070',
    },
    Hour: {
        display: 'flex',
        justifyContent: "start",
        paddingLeft: '5px',
        alignItems: 'center',
        fontFamily: 'Kalameh',
        fontSize: '18px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        textAlign: 'right',
        color: '#753cbe',
    },
    HypoIcon: {
        display: 'flex',
        justifyContent: "center",
        alignItems: 'center',
        color: "#4e4e4e",
        fontSize: '1.3rem'
    },
    sickName: {
        color: '#707070',
        fontFamily: 'Kalameh',
        fontSize: '20px',
        fontWeight: 'bold',
        margin: 0

    },
    expandedSickName: {
        color: '#753cbe',
        fontFamily: 'Kalameh',
        fontSize: '20px',
        fontWeight: 'bold',
        margin: 0
    },
    date: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: '#753cbe',
        fontFamily: 'Kalameh',
        fontSize: '18px',
        fontWeight: 'bold',
        // marginTop: '10px'
    },
    dateHeader: {
        color: '#753cbe',
        fontFamily: 'Kalameh',
        fontSize: '18px',
        fontWeight: 'bold',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    marginLogBook: {
        margin: '0 0 10px !important'
    },
    sickInfo: {
        fontFamily: 'Kalameh',
        fontSize: '16px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#753cbe !important',
        textAlign: 'right'
    },
    sickTitle: {
        fontFamily: 'Kalameh',
        fontSize: '16px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#707070 !important',
    },
    dataModal: {
        fontFamily: 'Kalameh',
        fontSize: '20px',
        textAlign: 'center',
        color: '#753cbe',
        fontWeight: 'bold',
        margin: 0

    },
    noDataContainer: {
        paddingTop: '63px',
        paddingBottom: '90px',
        // backgroundColor: '#ffffff',

    },
    noData: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    noDataText: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontFamily: 'Kalameh',
        fontSize: '16px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#753cbe',
        marginTop: 0,
        textAlign: 'center'
    },
    waiting: {
        fontFamily: 'Kalameh',
        fontSize: '16px',
        color: '#753cbe',
        paddingLeft: '23px',
        fontWeight: '600',
        textAlign: 'center',
        paddingTop: '10px',
        paddingBottom: '20px',
    },
    LogContainer: {
        backgroundColor: '#ffffff',
    },
    selectionLogContainer: {
        // display:'flex',
        // justifyContent:'end',
        // marginRight:'10px !important',
        // marginTop:'20px !important'
    },
    iconLog: {
        fontFamily: 'Kalameh',
        fontSize: '18px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        color: '#707070 !important',
        textAlign: 'center',
    },
    iconLogSelected: {
        color: '#753cbe !important'
    },
    iconLogNotSelected: {
        opacity: '0.6'

    },
    iconGrid: {
        fontSize: '24px !important',
        ['@media (min-width:600px)']: { // eslint-disable-line no-useless-computed-key
            fontSize: '28px !important'
        }
    },
    selectStyle: {
        // display: 'flex !important',
        // alignItems: 'center !important',
        // width: '218px !important',
        fontFamily: 'Kalameh !important',
        fontWeight: '700 !important',
    },
    low: { color: 'rgba(216, 29, 93, 1) !important' },
    inRange: { color: 'rgba(59, 186, 76, 1) !important' },
    high: { color: 'rgba(254, 177, 64, 1) !important' },
    select: {
        background: '#F4F4F4',
        border: '1px solid #FFFFFF',
        boxShadow: '-2px -2px 4px #FFFFFF, 4px 4px 10px rgba(0, 0, 0, 0.1) !important',
        borderRadius: '12px !important',
        width: '216px !important',
        "& ul": {
            display: 'grid',
            justifyContent: 'center',
            alignItems: 'center',
        },
        "& li": {
            width: '100% !important',
            background: '#FFFFFF',
            border: '1px solid #EEEEEE',
            boxShadow: '-2px -2px 10px #FFFFFF, 4px 4px 25px rgba(0, 0, 0, 0.08)',
            borderRadius: '12px',
            margin: '10px 0',
            fontFamily: 'Kalameh',
            fontWeight: '400',
            fontSize: '10px',
            height: "30px !important",
            minHeight: '30px'
            // padding: '0 !important',
            // backgroundColor: 'red'
        },
        '& li:nth-of-type(4)': {
            // border: '1px solid #D81D5D',
        },
        '& li:nth-of-type(1)': {
            fontWeight: '700',
        },
    },
    inRangeSelected: {
        background: '#FFFFFF !important',
        border: '1px solid rgba(59, 186, 76, 1) !important',
        transform: 'scale(1) !important'
    },
    highSelected: {
        background: '#FFFFFF !important',
        border: '1px solid rgba(254, 177, 64, 1) !important',
        transform: 'scale(1) !important'
    },
    lowSelected: {
        background: '#FFFFFF  !important',
        border: '1px solid #D81D5D !important',
        transform: 'scale(1) !important'
    },
    allSelected: {
        background: '#FFFFFF  !important',
        transform: 'scale(1) !important',
        color: '#707070 !important',
        fontSize: '10px'
    },
    endMessage: {
        fontFamily: 'Kalameh !important',
        fontSize: '16px !important',
        color: '#753cbe !important',
        fontWeight: '600 !important',
        textAlign: 'center',
    },
    // inputSelect: {
    //     fontFamily: 'dana',
    //     fontWeight: '700',
    //     fontDize: '10px',
    //     lineHeight: '16px',
    //     textAlign: 'center',
    //     color: "#707070"
    // }
    endMessage: {
        fontFamily: 'Kalameh !important',
        fontSize: '16px !important',
        color: '#753cbe !important',
        fontWeight: '600 !important',
        textAlign: 'center',
    },
};

export default LogBookStyles;